

export class HttpError {
  constructor(
    public message: string, 
    public statusCode: number) {
  }
}